/* BeyondADS product page — House of Garments (hp-)
   Bundle cards, per-piece variants, rewards bar mirroring /cart.js, gallery,
   viewers, sale pop-up, phone sticky bar, smooth dropdowns. */
(function () {
  'use strict';

  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  function money(cents) {
    if (window.HOG && typeof window.HOG.formatMoney === 'function') return window.HOG.formatMoney(cents);
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, v);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------ cart watcher (shared) */
  var cartListeners = [];
  var cartTimer = null;
  function scheduleCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(loadCart, 180);
  }
  function loadCart() {
    return window.__hpFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartListeners.forEach(function (fn) { fn(cart); }); })
      .catch(function () {});
  }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  if (!window.__hpFetch) {
    window.__hpFetch = window.fetch.bind(window);
    window.fetch = function (input) {
      var p = window.__hpFetch.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_RE.test(url)) p.then(scheduleCart, function () {});
      } catch (e) {}
      return p;
    };
    var xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      try {
        if (CART_RE.test(String(url))) this.addEventListener('loadend', scheduleCart);
      } catch (e) {}
      return xo.apply(this, arguments);
    };
    document.addEventListener('cart:updated', scheduleCart);
  }

  /* ------------------------------------------------------------- section */
  function init(root) {
    if (root.__hp) return;
    root.__hp = true;

    var data;
    try { data = JSON.parse(root.querySelector('[data-hp-data]').textContent); } catch (e) { return; }
    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });
    var single = data.variants.length === 1;

    var state = {
      tier: data.tier || 2,
      main: byId[data.selected] || data.variants[0],
      slots: [],
      active: 1,
      flash: -1,
      cart: null
    };

    /* ---------------- catalogue for mix & match ------------------------- */
    var catalog = {};
    (data.catalog || []).forEach(function (p) { catalog[p.id] = p; });
    var mainP = catalog[data.productId] || { id: data.productId, handle: data.handle, title: data.title, url: '', img: '' };
    mainP.variants = data.variants;
    mainP.available = true;
    catalog[mainP.id] = mainP;
    var vIndex = {};
    Object.keys(catalog).forEach(function (id) {
      (catalog[id].variants || []).forEach(function (v) { vIndex[v.id] = { v: v, p: catalog[id] }; });
    });

    var SIZE = { '2xs': '2XS', xxs: '2XS', xs: 'XS', s: 'S', small: 'S', m: 'M', medium: 'M', l: 'L', large: 'L', xl: 'XL', xlarge: 'XL', 'x-large': 'XL', '2xl': '2XL', xxl: '2XL', xxlarge: '2XL', '3xl': '3XL' };
    function sizeKey(o) { return SIZE[String(o).toLowerCase().replace(/\s+/g, '')] || null; }
    function sizeOf(v) {
      if (!v || !v.options) return null;
      for (var i = 0; i < v.options.length; i++) if (sizeKey(v.options[i])) return sizeKey(v.options[i]);
      return null;
    }
    var COLOURS = ['black', 'white', 'grey', 'gray', 'navy', 'royal', 'blue', 'olive', 'green', 'burgundy', 'red', 'pink', 'beige', 'brown', 'cream'];
    function colourOf(title) {
      var t = ' ' + String(title || '').toLowerCase().replace(/[^a-z]+/g, ' ') + ' ';
      for (var i = 0; i < COLOURS.length; i++) if (t.indexOf(' ' + COLOURS[i] + ' ') > -1) return COLOURS[i] === 'gray' ? 'grey' : COLOURS[i];
      return null;
    }

    // Suggestions: the item itself, then the OTHER groups (tee -> joggers,
    // layers, caps...), same-colour pieces first inside each group, then
    // more of its own group. Groups come from the section's mix_groups text.
    var groupOf = {};
    var suggestions = (function () {
      var groups = String(data.mixGroups || '').split(/\n+/).map(function (line) {
        var parts = line.split(':');
        if (parts.length < 2) return null;
        return parts.slice(1).join(':').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      }).filter(Boolean);
      var byHandle = {};
      Object.keys(catalog).forEach(function (id) { byHandle[catalog[id].handle] = catalog[id]; });
      var own = -1;
      groups.forEach(function (g, i) { if (own < 0 && g.indexOf(mainP.handle) > -1) own = i; });
      var order = [];
      groups.forEach(function (g, i) { if (i !== own) order.push(i); });
      if (own > -1) order.push(own);
      var colour = colourOf(mainP.title);
      var seen = {};
      seen[mainP.id] = 1;
      var list = [mainP];
      order.forEach(function (gi) {
        var ps = groups[gi].map(function (h) { return byHandle[h]; }).filter(function (p) { return p && p.available && !seen[p.id]; });
        if (colour) {
          ps = ps.filter(function (p) { return colourOf(p.title) === colour; })
            .concat(ps.filter(function (p) { return colourOf(p.title) !== colour; }));
        }
        ps.forEach(function (p) { seen[p.id] = 1; groupOf[p.id] = gi; list.push(p); });
      });
      Object.keys(catalog).forEach(function (id) {
        var p = catalog[id];
        if (!seen[p.id] && p.available) { seen[p.id] = 1; list.push(p); }
      });
      return list.slice(0, data.mixLimit || 16);
    })();

    function usedBefore(vid, upto) {
      var c = 0;
      for (var i = 0; i < upto; i++) if (state.slots[i] && state.slots[i].vid === vid) c++;
      return c;
    }
    function inCart(vid) {
      var c = 0;
      ((state.cart && state.cart.items) || []).forEach(function (it) { if (it.variant_id === vid) c += it.quantity; });
      return c;
    }
    // units still buyable: tracked stock minus what this shopper already has in the bag
    function left(v) {
      if (!v || !v.available) return 0;
      if (!(v.managed && v.deny)) return Infinity;
      return Math.max(0, v.inv - inCart(v.id));
    }
    function canTake(v, already) {
      return left(v) > already;
    }
    // strict: when piece 1 has a size, only accept that same size (or a
    // product with no sizes at all, like a cap).
    function pickVariant(p, slot, preferVid, strict) {
      var cands = (p.variants || []).filter(function (v) { return canTake(v, usedBefore(v.id, slot)); });
      if (!cands.length) return null;
      if (preferVid) {
        var pv = cands.find(function (v) { return v.id === preferVid; });
        if (pv) return pv;
      }
      var want = sizeOf(state.main);
      var sized = (p.variants || []).some(function (v) { return sizeOf(v); });
      if (want && sized) {
        var same = cands.filter(function (v) { return sizeOf(v) === want; });
        if (same.length) {
          var col = state.main && state.main.options.find(function (o) { return !sizeKey(o); });
          var sc = col ? same.find(function (v) { return v.options.indexOf(col) > -1; }) : null;
          return sc || same[0];
        }
        if (strict) return null;
      }
      return cands[0];
    }
    function usedProduct(pid, upto, byGroup) {
      for (var i = 1; i < upto; i++) {
        var s = state.slots[i];
        if (!s || s.pid === mainP.id) continue;
        if (s.pid === pid) return true;
        if (byGroup && groupOf[pid] !== undefined && groupOf[s.pid] === groupOf[pid]) return true;
      }
      return false;
    }
    function fillSlots() {
      if (!state.main) return;
      state.slots[0] = { pid: mainP.id, vid: state.main.id, touched: true };
      for (var i = 1; i < 3; i++) {
        var cur = state.slots[i];
        if (cur && cur.touched) continue;
        var p = null;
        var v = pickVariant(mainP, i, state.main.id, true);
        if (v) p = mainP;
        // same item can't fill it: suggest a DIFFERENT matching piece than
        // the earlier slots already hold (tee -> joggers, then a cap...)
        for (var g = 1; !v && g < suggestions.length; g++) {
          if (usedProduct(suggestions[g].id, i, true)) continue;
          v = pickVariant(suggestions[g], i, null, true);
          if (v) p = suggestions[g];
        }
        for (var k = 1; !v && k < suggestions.length; k++) {
          if (usedProduct(suggestions[k].id, i, false)) continue;
          v = pickVariant(suggestions[k], i, null, true);
          if (v) p = suggestions[k];
        }
        for (var j = 0; !v && j < suggestions.length; j++) {
          v = pickVariant(suggestions[j], i, null, false);
          if (v) p = suggestions[j];
        }
        state.slots[i] = { pid: p ? p.id : null, vid: v ? v.id : null, touched: false };
      }
    }
    function slotVariant(i) {
      var s = state.slots[i];
      var hit = s && vIndex[s.vid];
      return hit ? hit.v : null;
    }
    function slotProduct(i) {
      var s = state.slots[i];
      return (s && catalog[s.pid]) || null;
    }

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* ---------------- maths (mirrors the automatic discount) ------------- */
    function discounted(sub, count) {
      return count >= data.minQty ? sub - Math.round((sub * data.pct) / 100) : sub;
    }
    function tierCalc(n) {
      var sub = 0, was = 0;
      for (var i = 0; i < n; i++) {
        var v = slotVariant(i) || state.main || data.variants[0];
        sub += v.price;
        was += Math.max(v.compare || 0, v.price);
      }
      var total = discounted(sub, n);
      var save = was > total ? Math.round(((was - total) / was) * 100) : 0;
      return { sub: sub, was: was, total: total, save: save };
    }
    function stockProblem(n) {
      var need = {};
      for (var i = 0; i < n; i++) {
        var s = state.slots[i];
        if (!s || !s.vid) return { v: { title: 'Piece ' + (i + 1) }, left: 0, empty: true };
        need[s.vid] = (need[s.vid] || 0) + 1;
      }
      for (var id in need) {
        var v = vIndex[id] && vIndex[id].v;
        if (!v) continue;
        var l = left(v);
        if (need[id] > l) return { v: v, left: l, bagged: v.available && inCart(v.id) > 0 };
      }
      return null;
    }

    /* ---------------- variant picker ----------------------------------- */
    var optInputs = qa('[data-hp-option]');
    function selectedOptions() {
      var o = [];
      optInputs.forEach(function (i) { if (i.checked) o[+i.dataset.hpOption] = i.value; });
      return o;
    }
    function match(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (val, idx) { return val === opts[idx]; });
      });
    }
    function markUnavailable(sel) {
      optInputs.forEach(function (input) {
        var idx = +input.dataset.hpOption;
        var cand = sel.slice();
        cand[idx] = input.value;
        var m = data.variants.find(function (v) {
          return v.options.every(function (val, pos) {
            if (pos === idx) return val === input.value;
            return cand[pos] === undefined || val === cand[pos];
          });
        });
        var label = input.nextElementSibling;
        if (label) {
          var out = !m || left(m) <= 0;
          label.classList.toggle('is-out', out);
          label.title = out ? 'Out of stock' : '';
        }
      });
    }
    function onOption(initial) {
      initial = initial === true;
      if (!optInputs.length) { fillSlots(); render(); return; }
      var sel = selectedOptions();
      markUnavailable(sel);
      var cm = match(sel);
      sel.forEach(function (val, idx) {
        var el = q('[data-hp-opt-value="' + idx + '"]');
        if (!el) return;
        el.textContent = val + (cm && left(cm) <= 0 && idx === sel.length - 1 ? ' · Out of stock' : '');
      });
      var v = match(sel);
      if (!v) { state.main = null; render(); return; }
      state.main = v;
      fillSlots();
      var idInput = q('[data-hp-id]');
      if (idInput) idInput.value = v.id;
      if (!initial) try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      if (v.media && !initial) gallery.goToMedia(v.media);
      render();
    }
    optInputs.forEach(function (i) { i.addEventListener('change', onOption); });

    /* ---------------- bundle cards ------------------------------------- */
    var cards = qa('[data-hp-card]');
    cards.forEach(function (c) {
      var n = +c.dataset.hpCard;
      var nm = c.querySelector('.hp__card-name');
      if (n > 1 && nm && !nm.querySelector('.hp__card-sub')) {
        var sub = document.createElement('span');
        sub.className = 'hp__card-sub';
        sub.textContent = 'Mix & match any ' + n + ' items';
        nm.appendChild(sub);
      }
    });
    function setTier(n) {
      state.tier = n;
      cards.forEach(function (c) {
        var on = +c.dataset.hpCard === n;
        c.classList.toggle('is-selected', on);
        var r = c.querySelector('.hp__card-input');
        if (r) r.checked = on;
      });
      render();
    }
    cards.forEach(function (c) {
      var r = c.querySelector('.hp__card-input');
      if (r) r.addEventListener('change', function () { if (r.checked) setTier(+r.value); });
      c.addEventListener('click', function (e) {
        if (e.target.closest('[data-hp-panel]')) return;
        if (+c.dataset.hpCard !== state.tier) setTier(+c.dataset.hpCard);
      });
    });

    var truck = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 10h4l3 3v2.5h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
    function variantOptions(p, selected) {
      return (p.variants || []).map(function (v) {
        var ok = left(v) > 0;
        return '<option value="' + v.id + '"' + (v.id === selected ? ' selected' : '') + (ok ? '' : ' disabled') + '>' +
          esc(v.title) + (ok ? '' : ' (out of stock)') + '</option>';
      }).join('');
    }
    function priceFrom(p) {
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      if (!vs.length) vs = p.variants || [];
      return money(Math.min.apply(null, vs.map(function (v) { return v.price; })));
    }
    var mixScroll = 0;
    function renderPanel(card, n, calc) {
      var panel = card.querySelector('[data-hp-panel]');
      if (!panel) return;
      if (+card.dataset.hpCard !== state.tier) { panel.innerHTML = ''; return; }
      var old = panel.querySelector('[data-hp-mix]');
      if (old) mixScroll = old.scrollLeft;
      if (state.active > n - 1) state.active = n - 1;
      if (state.active < 1) state.active = 1;
      var main = state.main || data.variants[0];
      var html = '';
      if (n > 1) {
        html += '<p class="hp__mix-intro"><b>' + esc(data.mixHeading) + '</b></p>';
      }
      html += '<div class="hp__slots">';
      for (var i = 0; i < n; i++) {
        var p = i === 0 ? mainP : slotProduct(i);
        var v = i === 0 ? main : slotVariant(i);
        var img = (v && v.img) || (p && p.img) || '';
        var multi = p && p.variants && p.variants.length > 1;
        html += '<div class="hp__slot' + (i > 0 && i === state.active ? ' is-active' : '') + (i === 0 ? ' is-fixed' : '') + (i === state.flash ? ' hp__slot--flash' : '') + '" data-hp-slot="' + i + '">' +
          '<img src="' + esc(img) + '" alt="" width="44" height="44">' +
          '<div class="hp__slot-txt"><b>Piece ' + (i + 1) + '</b><span>' + esc(p ? p.title : 'Pick an item') + '</span></div>';
        if (i === 0) html += '<span class="hp__slot-fixed">' + esc(multi ? main.title : 'One size') + '</span>';
        else if (p && multi) html += '<select class="hp__piece-sel" data-hp-piece="' + i + '" aria-label="Piece ' + (i + 1) + ' option">' + variantOptions(p, v ? v.id : null) + '</select>';
        else html += '<span class="hp__slot-fixed">One size</span>';
        if (i > 0) html += '<button type="button" class="hp__swap' + (i === state.active ? ' is-on' : '') + '" data-hp-swap="' + i + '">' + (i === state.active ? 'Changing' : '&#8644; Change') + '</button>';
        html += '</div>';
      }
      html += '</div>';
      state.flash = -1;
      if (n > 1) {
        var act = state.slots[state.active];
        html += '<div class="hp__mix"><div class="hp__mix-head"><span>Choose <b>piece ' + (state.active + 1) + '</b></span>' +
          '<span class="hp__mix-nav"><button type="button" data-hp-mix-prev aria-label="Scroll left">&#8249;</button><button type="button" data-hp-mix-next aria-label="Scroll right">&#8250;</button></span></div>' +
          '<div class="hp__mix-track" data-hp-mix>';
        suggestions.forEach(function (sp) {
          var ok = !!pickVariant(sp, state.active, null, false);
          var on = act && act.pid === sp.id;
          html += '<button type="button" class="hp__mc' + (on ? ' is-on' : '') + (ok ? '' : ' is-off') + '" data-hp-mc="' + sp.id + '"' + (ok ? '' : ' disabled') + '>' +
            '<span class="hp__mc-img"><img src="' + esc(sp.img) + '" alt="" width="84" height="104" loading="lazy">' +
            (sp.id === mainP.id ? '<em>This item</em>' : '') + '</span>' +
            '<span class="hp__mc-t">' + esc(sp.title) + '</span><span class="hp__mc-p">' + priceFrom(sp) + '</span>' +
            '<span class="hp__mc-cta">' + (on ? '&#10003; Selected' : (ok ? 'Swap' : 'Out of stock')) + '</span></button>';
        });
        html += '</div></div>';
      }
      if (calc.total >= data.freeCents) {
        html += '<div class="hp__panel-free">' + truck + '<span><b>+ ' + esc(data.freeLabel) + '</b> · ' + esc(data.deliveryNote) + '</span></div>';
      }
      panel.innerHTML = html;
      var track = panel.querySelector('[data-hp-mix]');
      if (track) {
        track.scrollLeft = mixScroll;
        var pv = panel.querySelector('[data-hp-mix-prev]');
        var nx = panel.querySelector('[data-hp-mix-next]');
        if (pv) pv.addEventListener('click', function () { track.scrollBy({ left: -240, behavior: 'smooth' }); });
        if (nx) nx.addEventListener('click', function () { track.scrollBy({ left: 240, behavior: 'smooth' }); });
      }
      panel.querySelectorAll('[data-hp-piece]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var idx = +sel.dataset.hpPiece;
          state.slots[idx].vid = +sel.value;
          state.slots[idx].touched = true;
          render();
        });
      });
      panel.querySelectorAll('[data-hp-swap]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          state.active = +b.dataset.hpSwap;
          mixScroll = 0;
          render();
          var t = root.querySelector('.is-selected [data-hp-mix]');
          if (t) t.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
      panel.querySelectorAll('[data-hp-slot]').forEach(function (row) {
        row.addEventListener('click', function (e) {
          var idx = +row.dataset.hpSlot;
          if (idx === 0 || e.target.closest('select') || e.target.closest('[data-hp-swap]')) return;
          if (state.active !== idx) { state.active = idx; mixScroll = 0; render(); }
        });
      });
      panel.querySelectorAll('[data-hp-mc]').forEach(function (b) {
        b.addEventListener('click', function () {
          var sp = catalog[b.dataset.hpMc];
          var idx = state.active;
          var v = sp && pickVariant(sp, idx, sp.id === mainP.id && state.main ? state.main.id : null, false);
          if (!v) return;
          state.slots[idx] = { pid: sp.id, vid: v.id, touched: true };
          state.flash = idx;
          if (idx < state.tier - 1 && !state.slots[idx + 1].touched) { state.active = idx + 1; mixScroll = 0; }
          render();
        });
      });
    }

    /* ---------------- price, button, sticky ----------------------------- */
    var btn = q('[data-hp-atc]');
    var btnLabel = q('[data-hp-atc-label]');
    var btnTotal = q('[data-hp-atc-total]');
    var btnSep = q('[data-hp-atc-sep]');
    var errEl = q('[data-hp-error]');
    var sticky = q('[data-hp-sticky]');
    var stickyBtn = q('[data-hp-sticky-btn]');
    var busy = false;
    var justAdded = false;

    function render() {
      cards.forEach(function (c) {
        var n = +c.dataset.hpCard;
        var calc = tierCalc(n);
        var now = c.querySelector('[data-hp-card-now]');
        var was = c.querySelector('[data-hp-card-was]');
        var save = c.querySelector('[data-hp-card-save]');
        if (now) now.textContent = money(calc.total);
        if (was) { was.textContent = money(calc.was); was.hidden = calc.was <= calc.total; }
        if (save) { save.textContent = 'Save ' + calc.save + '%'; save.hidden = !calc.save; }
        renderPanel(c, n, calc);
      });

      var cur = tierCalc(state.tier);
      var nowEl = q('[data-hp-now]'), wasEl = q('[data-hp-was]'), saveEl = q('[data-hp-save]');
      if (nowEl) nowEl.textContent = money(cur.total);
      if (wasEl) { wasEl.textContent = money(cur.was); wasEl.hidden = cur.was <= cur.total; }
      if (saveEl) { saveEl.textContent = 'Save ' + cur.save + '%'; saveEl.hidden = !cur.save; }

      var stock = q('[data-hp-stock]');
      var m = state.main;
      if (stock) {
        var lft = m ? left(m) : 0;
        var low = m && lft > 0 && lft <= 5 && !data.preorder;
        stock.hidden = !low;
        stock.classList.toggle('hp__stock--low', !!low);
        if (low) stock.textContent = 'Only ' + lft + ' left' + (single ? '' : ' in ' + m.title);
      }

      if (!busy && !justAdded) setButton();
      var sub = q('[data-hp-sticky-sub]');
      if (sub) {
        var mixed = false;
        for (var si = 1; si < state.tier; si++) if (state.slots[si] && state.slots[si].pid !== mainP.id) mixed = true;
        sub.textContent = state.tier + (state.tier === 1 ? ' piece' : ' pieces') + (mixed ? ' · your mix' : (single || !m ? '' : ' · ' + m.title));
      }
      var st = q('[data-hp-sticky-total]');
      if (st) st.textContent = money(cur.total);
      var simg = q('[data-hp-sticky-img]');
      if (simg && m && m.img) simg.src = m.img;
      renderBar();
    }

    function setButton() {
      var m = state.main;
      var cur = tierCalc(state.tier);
      var label, disabled = false, err = '';
      if (!m) { label = 'Unavailable'; disabled = true; }
      else if (!m.available) { label = 'Out of stock'; disabled = true; err = (single ? 'This item' : 'Size ' + m.title) + ' is out of stock.'; }
      else if (left(m) <= 0) {
        label = 'Out of stock'; disabled = true;
        err = 'Out of stock: the last ' + (single ? 'piece' : m.title) + ' is already in your bag.';
      }
      else {
        var prob = stockProblem(state.tier);
        label = data.preorder ? 'Pre-order' : 'Add to bag';
        if (prob) {
          disabled = true;
          var nm = (vIndex[prob.v.id] && vIndex[prob.v.id].p.variants.length > 1) ? prob.v.title : 'this item';
          err = prob.empty
            ? 'Pick an item for ' + prob.v.title + '.'
            : prob.left > 0
              ? 'Only ' + prob.left + ' left in ' + nm + (prob.bagged ? ' (the rest is in your bag)' : '') + '. Pick another option for one of the pieces.'
              : 'Out of stock: ' + nm + (prob.bagged ? ' (the last one is in your bag)' : '') + '. Pick another option for that piece.';
          if (prob.v.id === m.id && prob.left === 0) label = 'Out of stock';
        }
      }
      if (btnLabel) btnLabel.textContent = label;
      var showTotal = !disabled;
      if (btnTotal) { btnTotal.textContent = money(cur.total); btnTotal.hidden = !showTotal; }
      if (btnSep) btnSep.hidden = !showTotal;
      if (btn) { btn.disabled = disabled; btn.classList.remove('is-added'); }
      if (errEl) { errEl.textContent = err; errEl.hidden = !err; }
      if (stickyBtn) {
        stickyBtn.disabled = disabled;
        stickyBtn.classList.remove('is-added');
        var sl = q('[data-hp-sticky-label]');
        if (sl) sl.textContent = label;
      }
    }

    function addBundle(opener) {
      if (busy || !state.main || !state.main.available || stockProblem(state.tier)) return;
      var qty = {};
      var order = [];
      for (var i = 0; i < state.tier; i++) {
        var id = state.slots[i].vid;
        if (!qty[id]) { qty[id] = 0; order.push(id); }
        qty[id]++;
      }
      var items = order.map(function (id) { return { id: +id, quantity: qty[id] }; });
      busy = true;
      if (btnLabel) btnLabel.textContent = 'Adding…';
      if (btn) btn.disabled = true;
      if (stickyBtn) stickyBtn.disabled = true;
      if (errEl) errEl.hidden = true;

      var done = function () {
        busy = false;
        if (btnLabel) btnLabel.textContent = 'Added ✓';
        if (btn) { btn.disabled = false; btn.classList.add('is-added'); }
        if (stickyBtn) {
          stickyBtn.disabled = false;
          stickyBtn.classList.add('is-added');
          var sl = q('[data-hp-sticky-label]');
          if (sl) sl.textContent = 'Added ✓';
        }
        justAdded = true;
        setTimeout(function () { justAdded = false; if (!busy) setButton(); }, 2200);
        scheduleCart();
      };
      var fail = function (err) {
        busy = false;
        var msg = (err && err.message) || '';
        loadCart().then(function () {
          setButton();
          if (errEl && errEl.hidden) {
            errEl.textContent = /cart|stock|sold|add more|quantity/i.test(msg) && !/went wrong/i.test(msg)
              ? msg
              : 'Sorry, part of this bundle just went out of stock. Please check your sizes.';
            errEl.hidden = false;
          }
        });
      };

      if (window.HOG && typeof window.HOG.addItems === 'function') {
        window.HOG.addItems(items, opener).then(done, fail);
      } else {
        window.fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message); });
          window.location.href = '/cart';
        }).catch(fail);
      }
    }

    var form = q('[data-hp-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addBundle(btn); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { addBundle(stickyBtn); });

    /* ---------------- rewards bar -------------------------------------- */
    var bar = q('[data-hp-bar]');
    function barModel(count, pre, total) {
      var ref = (state.main || data.variants[0]).price;
      var nFree = 99;
      for (var n = 1; n <= 30; n++) if (discounted(ref * n, n) >= data.freeCents) { nFree = n; break; }
      var order = nFree < data.minQty ? ['free', 'disc'] : ['disc', 'free'];
      var done = { disc: count >= data.minQty, free: total >= data.freeCents };
      if (done[order[1]] && !done[order[0]]) order = [order[1], order[0]];
      var frac = {
        disc: Math.min(count / data.minQty, 1),
        free: Math.min(total / data.freeCents, 1)
      };
      var pos;
      if (done[order[0]] && done[order[1]]) pos = 1;
      else if (done[order[0]]) pos = 0.5 + 0.5 * frac[order[1]];
      else pos = 0.5 * frac[order[0]];
      return { order: order, done: done, pos: pos, count: count, total: total };
    }
    function stepLabel(k) { return k === 'disc' ? data.rewardLabel : data.freeLabel; }
    function need(k, mdl) {
      if (k === 'disc') {
        var left = data.minQty - mdl.count;
        return 'add ' + left + ' more piece' + (left === 1 ? '' : 's') + ' for <b>' + esc(data.rewardLabel) + '</b>';
      }
      return 'add <b>' + money(data.freeCents - mdl.total) + '</b> more for <b>' + esc(data.freeLabel.toLowerCase()) + '</b>';
    }
    function renderBar() {
      if (!bar) return;
      var cart = state.cart || { item_count: 0, items_subtotal_price: 0, total_price: 0 };
      var mdl = barModel(cart.item_count, cart.items_subtotal_price, cart.total_price);
      var calc = tierCalc(state.tier);
      var pCount = cart.item_count + state.tier;
      var pPre = cart.items_subtotal_price + calc.sub;
      var pTotal = discounted(pPre, pCount);
      var proj = barModel(pCount, pPre, pTotal);
      // keep the projected fill on the current order of steps
      var pf = {
        disc: Math.min(pCount / data.minQty, 1),
        free: Math.min(pTotal / data.freeCents, 1)
      };
      var o = mdl.order;
      var ppos = proj.done[o[0]] && proj.done[o[1]] ? 1 : proj.done[o[0]] ? 0.5 + 0.5 * pf[o[1]] : 0.5 * pf[o[0]];

      var fill = bar.querySelector('[data-hp-bar-fill]');
      var ghost = bar.querySelector('[data-hp-bar-ghost]');
      if (fill) fill.style.width = (mdl.pos * 100).toFixed(1) + '%';
      if (ghost) ghost.style.width = (Math.max(ppos, mdl.pos) * 100).toFixed(1) + '%';
      var n1 = bar.querySelector('[data-hp-node="1"]'), n2 = bar.querySelector('[data-hp-node="2"]');
      var n0 = bar.querySelector('[data-hp-node="0"]');
      if (n0) n0.classList.toggle('is-done', cart.item_count > 0);
      if (n1) n1.classList.toggle('is-done', mdl.done[o[0]]);
      if (n2) n2.classList.toggle('is-done', mdl.done[o[1]]);
      var l0 = bar.querySelector('[data-hp-label="0"]');
      var l1 = bar.querySelector('[data-hp-label="1"]'), l2 = bar.querySelector('[data-hp-label="2"]');
      if (l0) l0.textContent = 'Your bag';
      if (l1) { l1.textContent = stepLabel(o[0]); l1.classList.toggle('is-done', mdl.done[o[0]]); }
      if (l2) { l2.textContent = stepLabel(o[1]); l2.classList.toggle('is-done', mdl.done[o[1]]); }

      var msg;
      if (mdl.done[o[0]] && mdl.done[o[1]]) msg = 'Unlocked everything: <b>' + esc(data.rewardLabel) + '</b> + <b>' + esc(data.freeLabel.toLowerCase()) + '</b>';
      else if (mdl.done[o[0]]) msg = 'Unlocked <b>' + esc(stepLabel(o[0]).toLowerCase()) + '</b> · ' + need(o[1], mdl);
      else {
        var t = need(o[0], mdl);
        msg = t.charAt(0).toUpperCase() + t.slice(1);
        if (cart.item_count === 0 && o[0] === 'disc') msg = 'Add ' + data.minQty + ' pieces to unlock <b>' + esc(data.rewardLabel) + '</b>';
      }
      var msgEl = bar.querySelector('[data-hp-bar-msg]');
      if (msgEl) msgEl.innerHTML = msg;

      var gains = [];
      ['disc', 'free'].forEach(function (k) { if (proj.done[k] && !mdl.done[k]) gains.push('<b>' + esc(k === 'disc' ? data.rewardLabel : data.freeLabel.toLowerCase()) + '</b>'); });
      var hint = bar.querySelector('[data-hp-bar-hint]');
      if (hint) {
        hint.hidden = !gains.length;
        hint.innerHTML = gains.length ? 'With this bundle you unlock ' + gains.join(' + ') : '';
      }
    }
    cartListeners.push(function (cart) {
      state.cart = cart;
      if (busy) renderBar();
      else onOption(true);
    });

    /* ---------------- gallery ------------------------------------------ */
    var gallery = (function () {
      var track = q('[data-hp-track]');
      var thumbs = qa('[data-hp-thumb]');
      var slides = qa('.hp__slide');
      var idx = 0;
      function setThumb(i) {
        idx = i;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
        var t = thumbs[i];
        var box = q('[data-hp-thumbs]');
        if (t && box) {
          var left = t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2;
          box.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }
      function go(i) {
        if (!track || !slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setThumb(i);
      }
      if (track) {
        var st;
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () {
            var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (i !== idx) setThumb(i);
          }, 60);
        }, { passive: true });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.hpThumb); }); });
      var prev = q('[data-hp-prev]'), next = q('[data-hp-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      return {
        goToMedia: function (mediaId) {
          var s = q('.hp__slide[data-media-id="' + mediaId + '"]');
          if (s) go(+s.dataset.index);
        }
      };
    })();

    /* ---------------- viewers ------------------------------------------ */
    var vw = q('[data-hp-viewers]');
    if (vw) {
      var vmin = +vw.dataset.min || 6, vmax = Math.max(+vw.dataset.max || 20, vmin);
      var vn = vmin + Math.floor(Math.random() * (vmax - vmin + 1));
      var vEl = vw.querySelector('[data-hp-viewers-n]');
      var tickV = function () {
        if (vEl) vEl.textContent = vn;
        setTimeout(function () {
          var step = Math.random() < 0.5 ? -1 : 1;
          if (vn + step < vmin || vn + step > vmax) step = -step;
          vn += step;
          tickV();
        }, 6000 + Math.random() * 6000);
      };
      tickV();
    }

    /* ---------------- dropdowns ---------------------------------------- */
    qa('[data-hp-acc]').forEach(function (d) {
      var sum = d.querySelector('summary');
      var body = d.querySelector('.hp-acc__body');
      if (!sum || !body) return;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(d.__t);
        if (d.open && !d.classList.contains('is-closing')) {
          d.classList.remove('is-opening');
          body.style.height = body.scrollHeight + 'px';
          void body.offsetHeight;
          d.classList.add('is-closing');
          body.style.height = '0px';
          d.__t = setTimeout(function () {
            d.open = false;
            d.classList.remove('is-closing');
            body.style.height = '';
          }, 360);
        } else {
          d.classList.remove('is-closing');
          d.open = true;
          var h = body.scrollHeight;
          body.style.height = '0px';
          body.style.opacity = '0';
          void body.offsetHeight;
          d.classList.add('is-opening');
          body.style.height = h + 'px';
          body.style.opacity = '1';
          d.__t = setTimeout(function () {
            d.classList.remove('is-opening');
            body.style.height = '';
            body.style.opacity = '';
          }, 360);
        }
      });
    });

    /* ---------------- phone sticky bar ---------------------------------- */
    if (sticky && btn) {
      var mq = window.matchMedia('(max-width: 749px)');
      var footer = document.querySelector('footer, .footer');
      var raf = 0;
      var check = function () {
        raf = 0;
        var on = false;
        if (mq.matches) {
          var r = btn.getBoundingClientRect();
          var nearFoot = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
          on = r.bottom < 0 && !nearFoot;
        }
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', String(!on));
        if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('hp-sticky-on', on);
      };
      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }

    /* ---------------- sale pop-up -------------------------------------- */
    (function () {
      var pop = q('[data-hp-pop]');
      if (!pop || !data.popups) return;
      try { if (sessionStorage.getItem('hp_pop_off') === '1') return; } catch (e) {}
      var DAY = 86400000;
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var byH = {};
      Object.keys(catalog).forEach(function (id) { byH[catalog[id].handle] = catalog[id]; });
      var list = (data.sales || []).map(function (s) {
        var p = String(s.date).split('-');
        var d = new Date(+p[0], +p[1] - 1, +p[2]);
        var days = Math.round((today - d) / DAY);
        var pr = byH[s.handle];
        return pr ? { city: s.city, title: pr.title, url: pr.url, img: pr.img, days: days } : { city: '' };
      }).filter(function (s) { return s.days >= 0 && s.days <= 45 && s.city; });
      if (!list.length) return;
      var i = 0, stopped = false, timer;
      var line = pop.querySelector('[data-hp-pop-line]');
      var meta = pop.querySelector('[data-hp-pop-meta]');
      var img = pop.querySelector('[data-hp-pop-img]');
      function blocked() {
        return document.querySelector('dialog[open]') || document.querySelector('cart-drawer.is-open, .menu-drawer.is-open');
      }
      function show() {
        if (stopped) return;
        if (blocked()) { timer = setTimeout(show, 14000); return; }
        var s = list[i % list.length];
        i++;
        line.innerHTML = 'Someone in <b>' + esc(s.city) + '</b> ordered <a href="' + esc(s.url) + '">' + esc(s.title) + '</a>';
        if (meta) meta.style.display = 'none';
        if (s.img) { img.src = s.img; img.hidden = false; } else img.hidden = true;
        pop.hidden = false;
        void pop.offsetHeight;
        pop.classList.add('is-in');
        timer = setTimeout(function () {
          pop.classList.remove('is-in');
          timer = setTimeout(show, 14000);
        }, 7000);
      }
      pop.querySelector('[data-hp-pop-close]').addEventListener('click', function () {
        stopped = true;
        clearTimeout(timer);
        pop.classList.remove('is-in');
        setTimeout(function () { pop.hidden = true; }, 400);
        try { sessionStorage.setItem('hp_pop_off', '1'); } catch (e) {}
      });
      timer = setTimeout(show, 6000);
    })();

    onOption(true);
    loadCart();
  }

  function boot() { document.querySelectorAll('[data-hp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
